import { Injectable } from '@angular/core';
import { EndpointsConfigService } from './endpoints-config.service';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LibraryApiService {

  constructor(
    private configuration: EndpointsConfigService,
    private httpService: HttpClientService
  ) { }

  /**
 * This is the pollPaymentAuthCodeStatus function
 * @param  cpDeviceId string
 * @returns Observable<any>
 */
  pollPaymentAuthCodeStatus(cpDeviceId: string, appRef?: string, cardId?: string): Observable<any> {
    let url;
    if (appRef || cardId) {
      if(cardId) {
        url = `${this.configuration.getCardsVerifySCAUrl}/${cardId}?oper=scaStatus&requestId=${cpDeviceId}`;
      } else {
        url = this.configuration.getApplicationDetails + '/' + appRef + "?op=doVerifySCA&requestId=" + cpDeviceId;
      }
    } else {
      url = this.configuration.getLoginPollAuthCodeUrl + "/" + cpDeviceId;
    }

    let methodType =  this.httpService.makePostReq({}, url);

    if(cardId) {
      methodType = this.httpService.makeGetReq(url);
    }

    //return of('AUTHORIZED');
    return methodType
      .pipe(
        map((res: any) => {
          // if (res.status == "SUCCESS") {
            return res.data.toUpperCase();
          // } else {
          //   return false;
          // }
        })
      );
  }
}
